// extracted by mini-css-extract-plugin
export default {"heroTitle":"NewHero_heroTitle__PNxnD","imageWrapper":"NewHero_imageWrapper__6GN3O","heroImage":"NewHero_heroImage__o4bBq","highlightedText":"NewHero_highlightedText__DQIvC"};